import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IsometricGrid from './IsometricGrid';
import { AuthContext } from '../context/AuthContext';
import { ErrorContext } from '../context/ErrorContext';
import Permission from '../utils/HasPermission';
import './css/LoadingSpinner.css';

const MapPage = () => {
  const { isAuthenticated, permissions, isAuthInitializing } = useContext(AuthContext);
  const { showError } = useContext(ErrorContext);
  const [isLoading, setIsLoading] = useState(true);
  const hasShownAuthErrorRef = useRef(false);
  const navigate = useNavigate();

  // Set loading to false when the user is available
  useEffect(() => {
    if (isAuthInitializing) {
      setIsLoading(true);
      return;
    }
    if (!!permissions) {
      setTimeout(() => {
        setIsLoading(false);
      }, 250);
    } else {
      setIsLoading(false);
    }
  }, [isAuthInitializing, permissions]);

  // Ensure all hooks are called at the top level
  const hasPermission = Permission("readTiles");
  const isUserAuthenticated = isAuthenticated();

  useEffect(() => {
    if (!isLoading && !isUserAuthenticated) {
      if (!hasShownAuthErrorRef.current) {
        showError("Verified users who log in can view their nation's map");
        hasShownAuthErrorRef.current = true;
      }
      navigate('/home', { replace: true });
      return;
    }

    hasShownAuthErrorRef.current = false;
  }, [isLoading, isUserAuthenticated, navigate, showError]);

  useEffect(() => {
    if (!isLoading && isUserAuthenticated && !hasPermission) {
      showError("You are not authorized to view the map, contact Clay for verification");
    }
  }, [isLoading, isUserAuthenticated, hasPermission, showError]);

  // Conditionally render based on state and permissions
  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!isUserAuthenticated) {
    return null;
  }

  if (!hasPermission) {
    return null;
  }

  if (hasPermission) {
    return (
      <div className="container">
        <IsometricGrid />
      </div>
    );
  }
};

export default MapPage;
